import styled from 'styled-components';

export const StyledPostsTabsContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 2px;

  button {
    width: 50%;
    padding: 16px;
    position: relative;

    &.active:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: ${({ theme }) => theme.palette.yellow[500]};
      bottom: 0;
      left: 0;
    }
  }
`;
